import React from 'react'

function PlotOwner() {
  return (
    <div>

      <div className="album py-2">
        <div className="container">
          <div className="row ">
            <div className="col-md-4">
              <iframe
                width="100%"
                height="315"
                src="https://www.youtube.com/embed/fRE_HQn1Gkw"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>

            <div className="col-md-4">
              <iframe
                width="100%"
                height="315"
                src="https://www.youtube.com/embed/5gEM7Uq58xQ"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>

            <div className="col-md-4">
              <iframe
                width="100%"
                height="315"
                src="https://www.youtube.com/embed/o1PWEebRU-o"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}

export default PlotOwner